module.exports = __webpack_public_path__ + "static/media/article_img.3bec7132.JPG";